import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {Row, Col} from 'react-flexbox-grid'
import config from 'config'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'

import Styles from './AppDisclaimer.css'


@CSSModules(Styles, {allowMultiple:true})
export default class AppDisclaimer extends Component {
  render() {
    // const disclaimIcon = require( '../../../static/images/investment-advisor-icon.png' )

    //
    return (
      <div styleName='ad-img-bckgrnd'>
        <ContainerDivs>
          <Row>
            <Col xs={12}>
              <div styleName='ad-cntr'>
                { /* <img
                  src={disclaimIcon}
                  styleName='ad-icn'
                  alt='Not an investment adviser'
                /> */ }
                <div styleName='ad-cpy'>
                  <h2 styleName='ad-hl'>
                    Disclaimer: As You Sow is not an investment adviser
                  </h2>
                  <div styleName='ad-p'>
                    As You Sow is not an investment adviser as that term is
                    defined under federal and state (California) laws and
                    regulations. As You Sow is a tax-exempt, nonprofit
                    organization dedicated to educating and empowering
                    shareholders to change corporations for the good through the
                    collection, analysis and dissemination of relevant information
                    to the public, free of charge. As You Sow does not provide
                    financial planning, legal or tax advice. Nothing on this
                    website shall constitute or be construed as an offering of
                    financial instruments, or as investment advice or investment
                    recommendations.
                    <br/>
                    <Link
                      to={config.routes.legal}
                      title='Legal disclaimer'
                    >
                      <span styleName='wht'>
                        See our full disclaimer<LinkIcon/>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </ContainerDivs>
      </div>
    )
  }
}

